import { createSelector } from 'reselect';

// Basic selector for production types state
export const getProductionTypes = state => state.production_types;

// Selector for production types data
export const getProductionTypesData = createSelector(
  getProductionTypes,
  productionTypes => productionTypes?.data || {}
);

// Selector for production types list (ordered, non-archived)
export const getProductionTypesList = createSelector(
  [getProductionTypesData, getProductionTypes],
  (data, productionTypes) => {
    const order = productionTypes?.order || [];
    return order
      .map(id => data[id])
      .filter(type => type && !type.archived)
      .concat(
        // Include any types that might not be in order but are not archived
        Object.values(data).filter(
          type => !type.archived && !order.includes(type.id)
        )
      );
  }
);

// Selector for production type by ID
export const getProductionTypeById = createSelector(
  [getProductionTypesData, (state, id) => id],
  (data, id) => data[id]
);
